import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef, useId } from 'react';
import { getCommonClassNameDefault } from '@skatteetaten/ds-core-utils';
import './styles.css';


const getIconVariantDefault = ()=>'systemIcon';
const getIconSizeDefault = ()=>'medium';

var styles = {
    "systemIcon": "Icon-module_systemIcon__6Ezdp",
    "systemIcon_small": "Icon-module_systemIcon_small__NWRxd",
    "systemIcon_medium": "Icon-module_systemIcon_medium__jgeSL",
    "systemIcon_large": "Icon-module_systemIcon_large__scnvK",
    "systemIcon_extraLarge": "Icon-module_systemIcon_extraLarge__Fbje2",
    "themeIcon": "Icon-module_themeIcon__5i1-V",
    "themeIcon_small": "Icon-module_themeIcon_small__04wkY",
    "themeIcon_extraLarge": "Icon-module_themeIcon_extraLarge__LYbH4",
    "themeIcon_medium": "Icon-module_themeIcon_medium__beTZv",
    "themeIcon_large": "Icon-module_themeIcon_large__gVw1H"
};

const Icon = /*#__PURE__*/ forwardRef(({ id, className = getCommonClassNameDefault(), lang, 'data-testid': dataTestId, title, variant = getIconVariantDefault(), size = getIconSizeDefault(), svgPath, ariaLabel }, ref)=>{
    const uniqueId = useId();
    const sizeClassName = styles[`${variant}_${size}`];
    const titleId = `svgtitle-${id ?? uniqueId}`;
    return /*#__PURE__*/ jsxs("svg", {
        ref: ref,
        id: id,
        className: `${styles[variant]} ${sizeClassName} ${className}`.trim(),
        lang: lang,
        "data-testid": dataTestId,
        viewBox: variant === 'systemIcon' ? '0 0 24 24' : '0 0 48 48',
        focusable: false,
        "aria-label": !title ? ariaLabel : undefined,
        "aria-labelledby": title ? titleId : undefined,
        "aria-hidden": !title && !ariaLabel,
        role: 'img',
        children: [
            title && /*#__PURE__*/ jsx("title", {
                id: titleId,
                children: title
            }),
            svgPath
        ]
    });
});
Icon.displayName = 'Icon';

export { Icon, getIconSizeDefault, getIconVariantDefault };
